export enum ImageType {
    SVG = "svg",
    IMG = "img",
    PDF = "pdf",
    TIFF = "tiff"
}
